import anime from 'animejs/lib/anime.es.js';
import { gizyAniamtion } from './gizyAnime';
import { initStoryGallery } from './storyGallery';
import { initMobileNavigation } from './mobileNavigation';
import { initFaqSearch } from './faqSearch';
import { initCookieConsent } from './cookieConsent';
import { initScrollToTop } from './scrollToTop';
import { initDeferredVideo } from './deferredVideo';

window.addEventListener('DOMContentLoaded', () => {
     gizyAniamtion(anime);
     initStoryGallery();
     initMobileNavigation();
     initFaqSearch();
     initCookieConsent();
     initScrollToTop();
     initDeferredVideo();
});


document.addEventListener('DOMContentLoaded', () => {
    // Zmienne (istniejące)
    const header = document.getElementById('header');
    const desktopSubmenuContainers = document.querySelectorAll('[data-desktop-submenu]');

    let isScrolled = false;
    // Funkcja do przełączania widoczności elementów
    const toggleVisibility = (element, show) => {
        element.classList.toggle('hidden', !show);
    };

    // Funkcja do aktualizacji nagłówka przy przewijaniu
    const updateHeader = () => {
        const scrolled = window.scrollY > 300;
        if (scrolled !== isScrolled) {
            isScrolled = scrolled;
            header?.classList.toggle('shrink', scrolled);
        }
    };

    // Obsługa przewijania (z debounce)
    let scrollTimeout;
    window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateHeader, 100);
    });

    // Obsługa podmenu na desktopie z opóźnieniem
    desktopSubmenuContainers.forEach((desktopSubmenuContainer) => {
        const desktopSubmenu = desktopSubmenuContainer.querySelector('[data-desktop-submenu-panel]');
        const desktopSubmenuTrigger = desktopSubmenuContainer.querySelector('[data-desktop-submenu-trigger]');
        if (!desktopSubmenu || !desktopSubmenuTrigger) {
            return;
        }
        let hideSubmenuTimeout;

        const showSubmenu = () => {
            clearTimeout(hideSubmenuTimeout);
            toggleVisibility(desktopSubmenu, true);
            desktopSubmenuTrigger.setAttribute('aria-expanded', 'true');
        };

        const hideSubmenu = () => {
            hideSubmenuTimeout = setTimeout(() => {
                toggleVisibility(desktopSubmenu, false);
                desktopSubmenuTrigger.setAttribute('aria-expanded', 'false');
            }, 300);
        };

        desktopSubmenuContainer.addEventListener('mouseenter', showSubmenu);
        desktopSubmenuContainer.addEventListener('mouseleave', hideSubmenu);
        desktopSubmenuContainer.addEventListener('focusin', showSubmenu);
        desktopSubmenuContainer.addEventListener('focusout', (event) => {
            if (!desktopSubmenuContainer.contains(event.relatedTarget)) {
                hideSubmenu();
            }
        });

        desktopSubmenu.addEventListener('mouseenter', () => {
            clearTimeout(hideSubmenuTimeout);
        });

        desktopSubmenu.addEventListener('mouseleave', hideSubmenu);

        if (desktopSubmenuTrigger.tagName === 'BUTTON') {
            desktopSubmenuTrigger.addEventListener('click', () => {
                if (desktopSubmenu.classList.contains('hidden')) {
                    showSubmenu();
                } else {
                    clearTimeout(hideSubmenuTimeout);
                    toggleVisibility(desktopSubmenu, false);
                    desktopSubmenuTrigger.setAttribute('aria-expanded', 'false');
                }
            });
        }

        desktopSubmenuContainer.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !desktopSubmenu.classList.contains('hidden')) {
                event.preventDefault();
                clearTimeout(hideSubmenuTimeout);
                toggleVisibility(desktopSubmenu, false);
                desktopSubmenuTrigger.setAttribute('aria-expanded', 'false');
                desktopSubmenuTrigger.focus();
            }
        });
    });

    // NOWA SEKCJA: Animacje sekcji przy przewijaniu
    const animateLeftSections = document.querySelectorAll('.animate-left');
    const animateRightSections = document.querySelectorAll('.animate-right');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        [...animateLeftSections, ...animateRightSections].forEach((section) => {
            section.style.opacity = '1';
            section.style.transform = 'none';
        });
        return;
    }

    // Ustaw początkowy stan dla sekcji
    [...animateLeftSections, ...animateRightSections].forEach((section) => {
        section.dataset.animated = 'false'; // Dodajemy atrybut data-animated
    });

    // Intersection Observer do wykrywania widoczności sekcji
    const observerOptions = {
        root: null, // Viewport
        rootMargin: '0px 100px 0px 100px', // Dodajemy margines w poziomie
        threshold: 0.1 // 10% sekcji musi być widoczne
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const element = entry.target;
            const isLeft = element.classList.contains('animate-left');
            const translateX = isLeft ? '-90%' : '90%';

            if (entry.isIntersecting && element.dataset.animated === 'false') {
                // Uruchom animację tylko, jeśli nie była wcześniej odtworzona
                element.dataset.animated = 'true';

                anime({
                    targets: element,
                    opacity: [0, 1],
                    translateX: [translateX, 0],
                    duration: 800,
                    easing: 'easeOutQuad',
                    delay: 100,
                    complete: () => {
                        // Po zakończeniu animacji ustaw stan
                        element.style.opacity = '1';
                        element.style.transform = 'translateX(0)';
                    }
                });
            } else if (!entry.isIntersecting && element.dataset.animated === 'true') {
                // Resetuj stan, gdy element wychodzi z widoku
                element.dataset.animated = 'false';
                element.style.opacity = '0';
                element.style.transform = `translateX(${translateX})`;
            }
        });
    }, observerOptions);

    // Obserwuj sekcje z klasami .animate-left i .animate-right
    [...animateLeftSections, ...animateRightSections].forEach((section) => {
        observer.observe(section);
    });
});
